module.exports = __webpack_public_path__ + "img/stand_linche_urge_cut.3e2c47f8.png";